var map = {
	"./about-emma.jpg": 4930,
	"./about-hadassa.jpg": 2834,
	"./about-harley.jpg": 7244,
	"./about-heva.jpg": 623,
	"./about-kate.jpg": 9206,
	"./about-liz.jpg": 2280,
	"./about-mark.jpg": 4923,
	"./about-nathan.jpg": 6276,
	"./about-rachel.jpg": 911,
	"./about-rose.jpg": 7707,
	"./about-school.jpg": 3980,
	"./about-zeynep.jpg": 7634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2997;